/**
 * Keeps the amount inside the add-to-cart button in sync with the selected
 * variant.
 *
 * On a variant change product-info.js replaces only <variant-picker> plus a
 * fixed list of ids (Price, Inventory, Sku, Availability, Volume,
 * PricePerItem). The button node itself is never re-rendered from the server,
 * and toggleAddButton() rewrites just `[name="add"] > span.m-add-to-cart--text`
 * -- an amount placed inside that span would be wiped on the first change.
 * Hence a sibling span, updated here from the variantChange event that the same
 * method emits one line later.
 *
 * Visibility is not handled here: `.m-add-to-cart[disabled]` hides the price in
 * CSS, which covers setUnavailable() too (it returns before emitting).
 */
(() => {
  // The tag lives inside the buy_buttons block, so a page with two product
  // sections parses it twice and would subscribe twice.
  if (window.MinimogAtcPriceBound) return;
  window.MinimogAtcPriceBound = true;

  const PRICE_SELECTOR = '[data-atc-price]';

  // Scoped to the <product-info> that emitted the event, and deliberately
  // without a document-wide fallback: a page can carry several product forms
  // (upsell, complementary products, a second featured product), and falling
  // back to the whole document would stamp one product's price onto another's
  // button. No match means this event is not ours -- do nothing.
  const scopeFor = (sectionId) =>
    document.querySelector(
      `product-info[data-section-id="${sectionId}"], product-info[data-original-section="${sectionId}"]`
    );

  const onVariantChange = (event) => {
    const variant = event?.data?.variant;
    if (!variant) return;

    const scope = scopeFor(event.data.sectionId);
    if (!scope) return;

    const money = formatMoney(variant.price, window.MinimogSettings.money_format);

    scope.querySelectorAll(PRICE_SELECTOR).forEach((price) => {
      const amount = price.querySelector('[data-atc-price-amount]');
      if (amount) amount.innerHTML = money;
    });
  };

  window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, onVariantChange);
})();
